export const FILTER_VISIBILITY_ITEM_COUNT = 2;
